export const getWhatsNewSeenKey = userId => (userId ? `portfoplus-whats-new-seen:${userId}` : null);

export const getWhatsNewSeenVersion = userId => {
  const key = getWhatsNewSeenKey(userId);
  return key ? localStorage.getItem(key) : null;
};

export const isWhatsNewUnseen = (userId, version) =>
  Boolean(version && Number(version) > (Number(getWhatsNewSeenVersion(userId)) || 0));

export const markWhatsNewSeen = (userId, version) => {
  const key = getWhatsNewSeenKey(userId);
  if (!key || !version) return false;

  if (isWhatsNewUnseen(userId, version)) localStorage.setItem(key, version);
  return true;
};

const getWhatsNewProgressKey = userId => (userId ? `portfoplus-whats-new-progress:${userId}` : null);

export const getWhatsNewProgress = userId => {
  const key = getWhatsNewProgressKey(userId);
  if (!key) return null;

  try {
    const parsed = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!parsed || !Number.isInteger(parsed.version)) return null;

    return {
      version: parsed.version,
      openedIds: Array.isArray(parsed.openedIds) ? parsed.openedIds : [],
      fromIndex: Number.isInteger(parsed.fromIndex) ? parsed.fromIndex : 0,
      returnPath: typeof parsed.returnPath === 'string' ? parsed.returnPath : ''
    };
  } catch (error) {
    return null;
  }
};

export const setWhatsNewProgress = (userId, progress) => {
  const key = getWhatsNewProgressKey(userId);
  if (!key || !Number.isInteger(progress?.version)) return false;

  sessionStorage.setItem(
    key,
    JSON.stringify({
      version: progress.version,
      openedIds: Array.isArray(progress.openedIds) ? progress.openedIds : [],
      fromIndex: Number.isInteger(progress.fromIndex) ? progress.fromIndex : 0,
      returnPath: typeof progress.returnPath === 'string' ? progress.returnPath : ''
    })
  );
  return true;
};

export const clearWhatsNewProgress = userId => {
  const key = getWhatsNewProgressKey(userId);
  if (!key) return false;

  sessionStorage.removeItem(key);
  return true;
};

export const remainingCount = (features, openedIds) => {
  const opened = new Set(openedIds || []);
  return (Array.isArray(features) ? features : []).filter(feature => !opened.has(feature?.id)).length;
};

export const getWhatsNewUnseenCount = (userId, releases) =>
  (releases || []).filter(release => isWhatsNewUnseen(userId, release.version)).length;

export const nextUnopenedSlide = (features, openedIds, fromIndex) => {
  const list = Array.isArray(features) ? features : [];
  if (!list.length) return 0;

  const opened = new Set(openedIds || []);
  const start = Number.isInteger(fromIndex) ? ((fromIndex % list.length) + list.length) % list.length : 0;

  for (let step = 1; step <= list.length; step += 1) {
    const index = (start + step) % list.length;
    if (!opened.has(list[index]?.id)) return index;
  }

  return start;
};

export const shouldAutoOpenWhatsNew = (unseen, progress, version) =>
  Boolean(unseen && version && !(progress && progress.version === version));
